import React, { useState } from 'react';

import { Button, Icon } from '~/ui';
import { EditCuratedExampleModal } from './EditCuratedExampleModal';

export const EditCuratedExample = ({
    surveyId,
    reportGroupId,
    descriptor,
    curatedDescriptorId,
    examples,
    example,
    searchTextValue
}) => {
    const [modalVisible, setModalVisible] = useState(false);

    return (
        <div>
            <Button icon onClick={() => setModalVisible(true)}>
                <Icon
                    size="24px"
                    type="edit"
                />
            </Button>
            {modalVisible ? (
                <EditCuratedExampleModal
                    surveyId={surveyId}
                    reportGroupId={reportGroupId}
                    descriptor={descriptor}
                    curatedDescriptorId={curatedDescriptorId}
                    examples={examples}
                    example={example}
                    searchTextValue={searchTextValue}
                    onClose={() => setModalVisible(false)}
                />
            ) : null}
        </div>
    )
}